export const defaultColumnWidth = 80;
export const rowHeight = 50;
